import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const today = new Date().toISOString().slice(0, 10);

function normalizeScope(scope) {
  return scope === 'all' ? 'all' : 'active';
}

const useHerdContextStore = create(
  persist(
    (set) => ({
      siteId: '',
      unitId: '',
      baharbandId: '',
      scope: 'active',
      denseMode: true,
      quickSearch: '',
      dateContext: today,
      setSiteId: (siteId) => set({ siteId: siteId || '', unitId: '' }),
      setUnitId: (unitId) => set({ unitId: unitId || '' }),
      setBaharbandId: (baharbandId) => set({ baharbandId: baharbandId || '' }),
      setScope: (scope) => set({ scope: normalizeScope(scope) }),
      setDenseMode: (denseMode) => set({ denseMode: !!denseMode }),
      setQuickSearch: (quickSearch) => set({ quickSearch: quickSearch || '' }),
      setDateContext: (dateContext) => set({ dateContext: dateContext || today }),
      hydrateFromPreferences: (preferences = {}) => set({
        siteId: preferences.siteId || '',
        unitId: preferences.unitId || '',
        baharbandId: preferences.baharbandId || '',
        scope: normalizeScope(preferences.scope),
        denseMode: typeof preferences.denseMode === 'boolean' ? preferences.denseMode : true,
        quickSearch: preferences.quickSearch || '',
        dateContext: preferences.dateContext || today,
      }),
      resetContext: () => set({ siteId: '', unitId: '', baharbandId: '', scope: 'active', denseMode: true, quickSearch: '', dateContext: today }),
    }),
    {
      name: 'herd-context-storage',
      partialize: (state) => ({
        siteId: state.siteId,
        unitId: state.unitId,
        baharbandId: state.baharbandId,
        scope: state.scope,
        denseMode: state.denseMode,
        quickSearch: state.quickSearch,
        dateContext: state.dateContext,
      }),
    }
  )
);

export default useHerdContextStore;
